import FollowButton, { FollowButtonProps } from './FollowButton';

export default FollowButton;
export type { FollowButtonProps };
